<template>
    <v-container fluid grid-list-xl>
        <v-layout wrap align-center>
            <v-flex xs12>
                <h1 class="heading">Personal Information</h1>
            </v-flex>
            <v-flex xs12 d-flex>
                <v-text-field label="First name" v-model="data.firstname" :rules="[rules.required]"/>
            </v-flex>
            <v-flex xs12 d-flex>
                <v-text-field label="Last name" v-model="data.lastname" :rules="[rules.required]"/>
            </v-flex>
            <v-flex xs12 d-flex>
                <v-text-field label="Cellphone number" type="number" v-model="data.cellphone" :rules="[rules.required, rules.cellphone]"/>
            </v-flex>
            <v-flex xs12 d-flex>
                <v-text-field label="ID number" type="number" v-model="data.id" :rules="[rules.required, rules.idnumber]"/>
            </v-flex>
            <v-flex xs12 d-flex>
                <v-text-field label="Password" type="password" v-model="data.password" :rules="[rules.required, rules.password]"/>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    var Luhn = require('luhn-js');
    var config = require('../../../variants/' + BUILD_VARIANT + '/config.js').default;

    export default {
        data() {
            return {
                data: {
                    firstname: '',
                    lastname: '',
                    cellphone: '',
                    id: '',
                    password: '',
                    gender: ''
                },
                rules: {
                    required(value) {
                        if (!value) {
                            return 'Required';
                        }

                        return true;
                    },
                    cellphone(value) {
                        var message = 'Please enter a valid cellphone number';

                        if (isNaN(value)) {
                            return message;
                        }

                        if (value.length < 10 || value.length > 12) {
                            return message;
                        }

                        if (value[0] !== '0' && (value[0] + value[1]) != '27') {
                            return message;
                        }

                        return true;
                    },
                    idnumber(value) {
                        var message = 'Please enter a valid ID number';

                        if (isNaN(value)) {
                            return message;
                        }

                        if (value.length != 13) {
                            return message;
                        }

                        if (!Luhn.isValid(value)) {
                            return message;
                        }

                        return true;
                    },
                    password(value) {
                        if (value.length < 6) {
                            return 'Please provide a password longer than 6 characters';
                        }

                        return true;
                    }
                }
            }
        },
        methods: {
            isValid() {
                return false;
            }
        },
        mounted() {
        }
    }
</script>